import React, { useState, useEffect } from "react";
import "./appointment-scheduling.scss";
import { fetchData } from "../../services/apiService";
import useAlertUtils from "../../utils/common.utils";
import Footer from "../../components/Footer/Footer";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import Header from "../../components/Header/Header";
import { useNavigate } from "react-router-dom";

function AvailableSlots() {
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const { alertError } = useAlertUtils();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchSlots = async () => {
      setLoading(true);

      try {
        const response = await fetchData("/api/appointment/available-times");
        if (response?.availableSlots) {
          setDates(response.availableSlots);
          if (response.availableSlots.length > 0) {
            setSelectedDate(response.availableSlots[0].date);
            setSlots(response.availableSlots[0].slots);
          }
        }
      } catch (err) {
        alertError("Error fetching slots.");
      } finally {
        setLoading(false);
      }
    };

    fetchSlots();
  }, []);

  const handleDateClick = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
    const selectedData = dates.find((d) => d.date === date);
    setSlots(selectedData ? selectedData.slots : []);
  };

  const handleSlotClick = (slot) => {
    setSelectedSlot(slot);
  };

  const handleContinueProcess = () => {
    navigate(
      `/app/booking-page?slotStart=${selectedSlot.startTime}&slotEnd=${selectedSlot.endTime}`
    );
  };

  return (
    <div className="booking-app">
      {token ? <Header /> : <PreLoginHeader />}

      <div className="booking-hero">
        <div className="hero-content">
          <h1>Schedule Your Consultation</h1>
          <p>Select an available time that works best for you</p>
        </div>
      </div>

      <div className="booking-container">
        <div className="booking-info">
          <div className="info-card">
            <h3>What to expect</h3>
            <ul>
              <li>
                <div className="icon">⏱️</div>
                <div className="text">15-minute video consultation</div>
              </li>
              <li>
                <div className="icon">👩‍⚕️</div>
                <div className="text">Board-certified providers</div>
              </li>
              <li>
                <div className="icon">💊</div>
                <div className="text">Personalized treatment plan</div>
              </li>
            </ul>
          </div>

          <div className="testimonial-card">
            <div className="quote">
              "The consultation was professional and the treatment has been
              life-changing."
            </div>
            <div className="author">- Sarah M.</div>
          </div>
        </div>
        <div className="booking-card">
          <div className="booking-header">
            <div className="step-indicator active">1</div>
            <h2>Select Date & Time</h2>
          </div>

          {!loading ? (
            <>
              <div className="date-picker">
                <h3>Available Dates</h3>
                <div className="date-scroller">
                  {dates.map(({ date, slots }) => {
                    const day = new Date(date).toLocaleDateString("en-US", {
                      weekday: "short",
                    });
                    const monthDay = new Date(date).toLocaleDateString(
                      "en-US",
                      {
                        month: "short",
                        day: "numeric",
                      }
                    );

                    return (
                      <button
                        key={date}
                        className={`date-card ${
                          date === selectedDate ? "active" : ""
                        }`}
                        onClick={() => handleDateClick(date)}
                      >
                        <span className="day">{day}</span>
                        <span className="date">{monthDay}</span>
                        <span className="slots-available">
                          {slots.length} slots
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="time-picker">
                <h3>Available Times</h3>
                {slots.length > 0 ? (
                  <div className="time-grid">
                    {slots.map((slot, index) => (
                      <button
                        key={index}
                        className={`time-slot ${
                          selectedSlot === slot ? "selected" : ""
                        }`}
                        onClick={() => handleSlotClick(slot)}
                      >
                        {new Date(slot.startTime).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="no-slots">
                    <p>No available time slots for this date</p>
                  </div>
                )}
              </div>

              <button
                className="continue-btn"
                onClick={handleContinueProcess}
                disabled={!selectedSlot}
              >
                Confirm Appointment
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12H19M19 12L12 5M19 12L12 19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </>
          ) : (
            <div className="loading-state">
              <div className="spinner"></div>
              <p>Loading available slots...</p>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AvailableSlots;
